import script from "./AnnualReviewStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualReviewStatus.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/card-rizz.css?vue&type=style&index=0&id=7d8d20ff&scoped=true&lang=css&external"
import "./AnnualReviewStatus.vue?vue&type=style&index=1&id=7d8d20ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8d20ff"]])

export default __exports__